import React, { ReactNode } from 'react'
import { Swiper } from "swiper/react";
import "swiper/css/pagination";
import "swiper/css/navigation";
import "swiper/css/scrollbar";
import "swiper/css/effect-cards";
import { Pagination, Navigation, Autoplay, EffectFade, EffectCards } from 'swiper/modules';

import "swiper/css";

interface props {
    spaceBetween?: number | undefined;
    slidesPerView?: number | undefined;
    onSlideChange?: any;
    children?: ReactNode;
    pagination?: boolean;
    className?: string;
    navigation?: any;
    autoplay?: any;
    style?: any;
    onSwiper?: any;
    initialSlide?: any;
}


const Carousel = ({
    spaceBetween = 20,
    slidesPerView = 1,
    onSlideChange,
    children,
    pagination,
    className = "main-caro",
    navigation,
    autoplay,
    style,
    onSwiper,
    initialSlide
}: props) => {
    return (
        <div>
            <Swiper
                spaceBetween={spaceBetween}
                slidesPerView={slidesPerView}
                onSlideChange={onSlideChange}
                modules={[Pagination, Navigation, Autoplay, EffectFade, EffectCards]}
                pagination={pagination}
                navigation={navigation}
                className={`${className} w-100`}
                autoplay={autoplay}
                style={style}
                onSwiper={onSwiper}
                initialSlide={initialSlide}
            >
                {children}
            </Swiper>
        </div>
    )
}

export default Carousel